var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateForm',{ref:_vm.name,class:_vm.className,attrs:{"schema":_vm.schemaComputed,"name":_vm.name},on:{"submit":_vm.onSubmit},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }